import { USER_TOKEN_ADD, USER_TOKEN_REMOVE, USER_SESSION_EXPIRED, USER_TOKEN_DETAILS_UPDATE, APP_LOGIN_MENU, USER_DEFAULT_BRANCH, MSAL_LOADING } from '../../types'
import http from '@/utils/ajax'
import Router from '@/router'
import { initials } from '@/utils/name'
import StompClient from '@/websocket'
import { extractMenu } from '@/utils/extract'
import { logout as msSSOLogout } from '../../../config/msalPlugin'
import store from '../../../store'

const state = {
  token: '',
  timestamp: undefined,
  firstName: '',
  lastName: '',
  email: '',
  usrId: undefined,
  inactiveInterval: 0,
  isLogin: false,
  changePassword: false,
  twoFA: false,
  privileges: [],
  loginMessages: [],
  userBranch: '',
  defUserBranch: '',
  userRoles: '',
  msalAppLoad: false,
  msalLoading: false
}

const getters = {
  userDefBranch: state => {
    return state.defUserBranch
  },
  userBranch: state => {
    return state.userBranch
  },
  userRoles: state => {
    return state.userRoles
  },
  userInitials: state => {
    return initials(state.firstName, state.lastName)
  },
  userFullName: state => {
    return state.lastName + ', ' + state.firstName
  },
  userId: state => {
    return state.usrId
  },
  checkAccess: (state) => {
    return (privileges) => {
      let result = false
      if (privileges && privileges.length > 0) {
        for (var i = 0; i < privileges.length; i++) {
          const privilege = privileges[i]
          let filteredPrivileges = []
          // Privilege equals
          filteredPrivileges = state.privileges.filter(myPrivilege => myPrivilege === privilege)
          if (filteredPrivileges && filteredPrivileges.length > 0) {
            result = true
          }
        }
      }
      return result
    }
  }
}

const mutations = {
  [USER_TOKEN_ADD](state, data) {
    state.token = data.token
    state.timestamp = new Date()
    state.firstName = data.firstName
    state.lastName = data.lastName
    state.email = data.email
    state.usrId = data.usrId
    state.usrRefId = data.usrRefId
    state.inactiveInterval = data.inactiveInterval
    state.isLogin = true
    state.changePassword = data.changePassword
    state.twoFA = data.twoFA
    state.privileges = data.privileges
    state.loginMessages = data.loginMessages
    state.defUserBranch = data.defUserBranch
    state.userRoles = data.userRoles
  },
  [USER_TOKEN_REMOVE](state) {
    state.token = ''
    state.timestamp = undefined
    state.firstName = ''
    state.lastName = ''
    state.email = ''
    state.usrId = undefined
    state.usrRefId = ''
    state.inactiveInterval = 0
    state.isLogin = false
    state.changePassword = false
    state.twoFA = false
    state.privileges = []
    state.loginMessages = []
    state.userBranch = ''
    state.defUserBranch = ''
    state.userRoles = ''
  },
  [USER_TOKEN_DETAILS_UPDATE](state, data) {
    state.firstName = data.firstName
    state.lastName = data.lastName
    state.email = data.email
  },
  // AR-28/Jun: Added for selecting user branch after logged in
  [USER_DEFAULT_BRANCH](state, data) {
    state.userBranch = data
  },
  [MSAL_LOADING](state, data) {
    state.msalLoading = data
  }
}

function logoutCommit(context, forceReload) {
  context.commit(USER_TOKEN_REMOVE)
  if (!forceReload) {
    context.commit(USER_SESSION_EXPIRED)
  }
}
const actions = {
  async processLoginForm({ commit, dispatch }, response) {
    const { data } = response
    const commitForm = {
      token: response.headers['x-auth-token'],
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      usrId: data.usrId,
      usrRefId: data.usrRefId,
      defUserBranch: data.defaultBranch,
      userRoles: data.userRoles,
      inactiveInterval: data.inactiveInterval,
      changePassword: data.changePassword,
      twoFA: data.twoFA,
      privileges: data.privileges,
      loginMessages: data.messages
    }
    // Commit to store token
    commit(USER_TOKEN_ADD, commitForm)

    // Commit to extract out menu
    const menu = extractMenu(data._links)
    const commitMenu = {
      menu: menu,
      wsLink: data.wsLink,
      wsSubscribe: data.wsSubscribe
    }
    commit(APP_LOGIN_MENU, commitMenu)

    // Post Login Init
    dispatch('postLoginInit')
  },
  async logout(context, forceReload = false) {
    try {
      // Disconnect websocket
      StompClient().then((result) => {
        result.disconnect()
      })
      const apiURL = context.rootState.app.menu.logout
      if (apiURL) {
        await http.post(apiURL).then(respone => {
          if (respone) {
            if (localStorage.getItem('accessToken') && store.state.app.dataMap.msSSOEnabled) {
              msSSOLogout()
            } else {
              redirectLoginPage(context, forceReload)
            }
          }
        })
      }
    } catch (err) {
      console.error(err)
    }
  }
}

function redirectLoginPage(context, forceReload) {
  logoutCommit(context, forceReload)
  Router.push({ name: 'login' })
  // AR: Added 20-Jan-2020
  context.commit(USER_DEFAULT_BRANCH, '')
  if (forceReload) {
    window.location.reload()
  }
}

export default {
  // It supports state, getters, mutations, actions
  state,
  getters,
  mutations,
  actions
}
